import { NgModule } from "@angular/core";
import { Routes, RouterModule, Router } from "@angular/router";
import { Shell } from "@shell/shell.service";
import { authGuard } from "@authentication/auth.guard";
import { TipoUsuario } from "@shared/enums/tipoUsuario";
import { ReportsIndexComponent } from "./reports-index/reports-index.component";
import { StockIndexComponent } from "./stock/stock-index/stock-index.component";
import { StockActualComponent } from "./stock/stock-actual/stock-actual.component";
import { ConsolidadoComponent } from "./informes/consolidado/consolidado.component";
import { ResolucionMensualComponent } from "./informes/resolucion-mensual/resolucion-mensual.component";
import { InformesIndexComponent } from "./informes/informes-index/informes-index.component";
import { AuthService } from "@authentication/auth.service";
import { ReporteMovimientosComponent } from "./informes/reporte-movimientos/reporte-movimientos.component";
import { ReporteAnulacionAerovalesComponent } from "./informes/reporte-anulacion-aerovales/reporte-anulacion-aerovales.component";
import { InterfacesIndexComponent } from "./interfaces/interfaces-index/interfaces-index.component";
import { InterfaceClientesComponent } from "./interfaces/interfaz-clientes/interfaz-clientes.component";
import { InterfaceSapComponent } from "./interfaces/interfaz-sap/interfaz-sap.component";
import { InterfaceDocumentosComercialesComponent } from "./interfaces/interfaz-documentos-comerciales/interfaz-documentos-comerciales.component";
import { InterfaceStockComponent } from "./interfaces/interfaz-stock/interfaz-stock.component";
import { LegajosIndexComponent } from "./legajos/legajos-index/legajos-index.component";
import { LegajosAerovalesFacturasComponent } from "./legajos/legajos-aerovales-facturas/legajos-aerovales-facturas.component";
import { LegajosAuditoriasComponent } from "./legajos/legajos-auditorias/legajos-auditorias.component";

const routes: Routes = [
  Shell.childRoutes([
    {
      path: "reportes",
      component: ReportsIndexComponent,
      canActivate: [authGuard],
      data: { roles: [TipoUsuario.TUTOR, TipoUsuario.SUPERVISOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.RESPRODUCTO, TipoUsuario.SOPORTE, TipoUsuario.CONSAEROVALES, TipoUsuario.FACTURACION, TipoUsuario.SEGURIDADTABLAS, TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.REFACTURACION, TipoUsuario.EJECUTIVOCUENTA, TipoUsuario.APROBADORBYR] },
      children: [
        {
          path: 'stock',
          component: StockIndexComponent,
          canActivate: [authGuard],
          data: { roles: [TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE, TipoUsuario.CONSAEROVALES] },
          children: [
            {
              path: 'stockActual',
              component: StockActualComponent,
              canActivate: [authGuard],
              data: { roles: [TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE, TipoUsuario.CONSAEROVALES] }
            }
          ]
        },
        {
          path: 'legajos',
          component: LegajosIndexComponent,
          canActivate: [authGuard],
          data: { roles: [TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.APROBADORBYR, TipoUsuario.EJECUTIVOCUENTA, TipoUsuario.FACTURACION, TipoUsuario.REFACTURACION, TipoUsuario.RESPRODUCTO]},
          children: [
            {
              path: 'legajosAerovalesFacturas',
              component: LegajosAerovalesFacturasComponent,
              canActivate: [authGuard]
            },
            {
              path: 'legajosAuditorias',
              component: LegajosAuditoriasComponent,
              canActivate: [authGuard]
            }
          ]
        },
        {
          path: 'informes',
          component: InformesIndexComponent,
          canActivate: [authGuard],
          data: { roles: [TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SUPERVISOR, TipoUsuario.SOPORTE, TipoUsuario.RESPRODUCTO, TipoUsuario.CONSAEROVALES] },
          children: [
            {
              path: 'consolidado',
              component: ConsolidadoComponent,
              canActivate: [authGuard],
              data: { roles: [TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE, TipoUsuario.CONSAEROVALES] }
            },
            {
              path: 'resolucionMensual',
              component: ResolucionMensualComponent,
              canActivate: [authGuard],
              data: { roles: [TipoUsuario.RESPRODUCTO, TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE, TipoUsuario.CONSAEROVALES] }
            },
            {
              path:'reporteMovimientos',
              component: ReporteMovimientosComponent,
              canActivate: [authGuard],
              data: { roles: [TipoUsuario.RESPRODUCTO, TipoUsuario.SUPERVISOR, TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE]}
            },
            {
              path: 'anulacionAerovales',
              component: ReporteAnulacionAerovalesComponent,
              canActivate: [authGuard],
              data: { roles: [TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE]}
            }
          ]
        },
        {
          path: 'interfaces',
          component: InterfacesIndexComponent,
          canActivate: [authGuard],
          data: { roles: [TipoUsuario.SOPORTE, TipoUsuario.FACTURACION, TipoUsuario.SEGURIDADTABLAS] },
          children: [
            {
              path: 'interfaceClientes',
              component: InterfaceClientesComponent,
              canActivate: [authGuard],
              data: { roles: [TipoUsuario.SOPORTE, TipoUsuario.FACTURACION, TipoUsuario.SEGURIDADTABLAS] }
            },
            {
              path: 'interfaceDocumentosComerciales',
              component: InterfaceDocumentosComercialesComponent,
              canActivate: [authGuard],
              data: { roles: [TipoUsuario.SOPORTE, TipoUsuario.FACTURACION, TipoUsuario.SEGURIDADTABLAS] }
            },
            {
              path:'interfaceSAP',
              component: InterfaceSapComponent,
              canActivate: [authGuard],
              data: { roles: [TipoUsuario.SOPORTE, TipoUsuario.FACTURACION, TipoUsuario.SEGURIDADTABLAS]}
            },
            {
              path:'interfaceStock',
              component: InterfaceStockComponent,
              canActivate: [authGuard],
              data: { roles: [TipoUsuario.SOPORTE, TipoUsuario.FACTURACION, TipoUsuario.SEGURIDADTABLAS]}
            }
          ]
        }
      ]
    }
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ReportesRoutingModule {
  constructor(
    private authService: AuthService,
    private router: Router)
    {
      this.router.events
        .subscribe((e)=>{          
          if (e['url'] && e['url'] == '/reportes') {
            this.redireccionar();
          } else if (e['url'] == '/reportes/informes') {
            this.redireccionarInforme();
          } else if (e['url'] == '/reportes/interfaces') {
            this.redireccionarInterfaces();
          } else if (e['url'] == '/reportes/legajos') {
            this.redireccionarLegajos();
          }
        });
    }

    redireccionar() {      
      if (this.authService.hasRole(TipoUsuario.TUTOR, TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.SOPORTE, TipoUsuario.CONSAEROVALES)) {
        this.router.navigate(['/reportes/stock/stockActual']);
      } else if (this.authService.hasRole(TipoUsuario.RESPRODUCTO)) {
        this.router.navigate(['/reportes/informes/resolucionMensual']);
      } else if(this.authService.hasRole(TipoUsuario.FACTURACION, TipoUsuario.SEGURIDADTABLAS)) {
        this.router.navigate(['/reportes/interfaces/interfaceClientes'])
      } else if (this.authService.hasRole(TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.EJECUTIVOCUENTA, TipoUsuario.APROBADORBYR, TipoUsuario.REFACTURACION)) {
        this.router.navigate(['reportes/legajos/legajosAerovalesFacturas'])
      } else {
        this.router.navigate(['/reportes/informes/reporteMovimientos']);
      }
    }

    redireccionarInforme() {
      this.router.navigate(['/reportes/informes/consolidado'])
    }

    redireccionarInterfaces() {
      this.router.navigate(['reportes/interfaces/interfaceClientes'])
    }
    
    redireccionarLegajos() {
      this.router.navigate(['reportes/legajos/legajosAerovalesFacturas'])
    }
}
